import styled, { css } from '@xstyled/styled-components';
import LlamaImg from '../llamaSad.svg';
import { Props } from '../LlamaModal';

export const SadLlama = styled(LlamaImg)<Props>`
  position: absolute;
  bottom: -150px;
  z-index: 1;
  ${p =>
    p.horizontal === 'right'
      ? css`
          right: -140px;
          top: 0;
          /* transform: scaleX(-1); */
        `
      : p.horizontal === 'center'
      ? css`
          left: -16px;
        `
      : css`
          left: -50px;
          top: 0;
        `}

  @media (max-width: sm) {
    z-index: -1;
    transform: scaleX(1) scaleY(1);
    right: -100px;
    margin-top: -40px;
  }
`;
